module.exports = __webpack_public_path__ + "static/media/al.b264ab36.png";